import { SelectOption } from "global";
import { SaleType } from "../types";
import { ProposalSaleType } from "@trnsact/trnsact-shared-types";

export const defaultCashTerm = "0";

export const saleTypeOptions: SelectOption<SaleType>[] = [
  { label: "Financing", value: SaleType.Financing },
  { label: "Cash", value: SaleType.Cash },
];

export const proposalToSaleTypeMap: Record<ProposalSaleType, SaleType> = {
  [ProposalSaleType.CashWithAftermarketMenu]: SaleType.Cash,
  [ProposalSaleType.FinanceOnly]: SaleType.Financing,
  [ProposalSaleType.FinanceWithAftermarketMenu]: SaleType.Financing,
};
